// removed by extract-text-webpack-plugin
module.exports = {"card":"_1xlmjLp93Nioi_SPEBfSuc","compact":"z3RuoXWUxM9T0AX-j2vOK","image":"_3yqW9_s7dv8B6hyjNscVpP","list":"_3fFdKGnqAziXKUhKJFPPM8","imageWrapper":"_3Ay3Hzhvm5svpdZ--ci-F4","info":"_3Lmssp0Bzdch7XV8yTniEF","hasImage":"LUEApNWb72XhsAVYvnYwd","name":"_3pIVK9OgK7eGMukjKLLFCv","address":"_3QfrQYCCensLA1w2BwD9oR","text":"_1NQwIa_mp0KxOZbToXA9BG","details":"PSz7nYs5be0KQs0xZ9PkN","region":"_2Zd2yb_6Rmlwwv1n9XsVNQ","division":"_3AVaXDtjc28mhNQKgmSuyM","externalUrl":"_2W2hrA2yPCl3xpAUT0nhoa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectCard/ProjectCard.module.scss
// module id = 797
// module chunks = 0